<template>
    <ul
        v-if="props.title"
        class="flex justify-en relative"
    >
        <li
            v-if="editable"
            @click="notEditable"
            class="absolute right-20 -top-8 border rounded-t-lg py-1 px-4 bg-gray-200 cursor-pointer"
        >
            Save
        </li>
        <h1
            :class="{ 'p-2 border border-gray-600 rounded-l-md rounded-br-md' : editable }"
            class="text-3xl mr-7 mb-4"
            :contenteditable="editable"
        >
        {{ title }}
        </h1>
        <div>
            <svg @click="makeEditable()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-7 h-7 mr-6 cursor-pointer">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
        </svg>
        </div>
    </ul>

    <span
        v-if="props.text"
        class="flex relative w-full"
    >
        <div
            v-if="editable"
            class="absolute -top-8 flex gap-x-1"
            :class="[star === true ? 'right-18' : 'right-13']"
        >
           <button

               @click="notEditable"
               type="button"
               class="border h-8 rounded-t-lg py-1 px-4 bg-gray-200 cursor-pointer"
           >
            Cancel
            </button>
            <div class="flex flex-col">
               <button
                   @click="moreChoices"
                   type="button"
                   class="border h-8 rounded-t-lg py-1 px-5 bg-gray-200 cursor-pointer"
               >
                More
                </button>
                <ul
                    class="hidden bg-gray-200 pr-4 pl-4 border border-gray-400 rounded-b-lg"
                    id="expandButton"
                >
                    <li
                        v-for="o in moreOptions"
                        @click="chooseOption"
                        class="cursor-pointer"
                    >
                        {{ o.option }}
                    </li>
                </ul>
            </div>

            <button
                @click="notEditable"
                type="button"
                class="border h-8 rounded-t-lg py-1 px-4 bg-gray-200 cursor-pointer"
            >
                Save
            </button>
        </div>

        <div class="w-full flex flex-col mb-2">
            <p
                id="expand"
                :class="[editable ? 'p-2 border border-gray-600 rounded-l-md rounded-br-md' : 'max-h-32 overflow-hidden']"
                class="pt-4 text-lg mr-7 w-full"
                :contenteditable="editable"
            >
        {{ text }}
        </p>
        <span v-if="showMoreText && !editable && showLess === true"
              class="w-1/2 underline mr-8 mt-4 mb-10 text-lg font-light cursor-pointer"
              @click="show"
        >
            + Vis mer av teksten
        </span>
        <span v-if="showMoreText && !editable && showMore === false"
              class="w-1/2 underline mr-8 mt-4 mb-10 text-lg font-light cursor-pointer"
              @click="noShow"
        >
          - Vis mindre av teksten
        </span>
        </div>

        <div class="mt-4 flex justify-end">
           <svg @click="makeEditable()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-7 h-7 cursor-pointer" :class="[star === true ? 'mr-3' : 'mr-6']">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
        </svg>
        </div>
        <div v-if="star" @click="highlightStars()" class="mt-4">
            <div v-if="highlightStar === false">
                <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="star w-7 h-7 hover:text-icon hover:cursor-pointer">
              <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
            </svg>
            </div>
            <div v-else>
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-7 h-7 text-icon">
                <path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clip-rule="evenodd" />
            </svg>
            </div>
        </div>
    </span>
</template>

<script setup>
import {ref} from "vue";

const props = defineProps({
    title: {
        type: String,
        required: false,
    },
    text: {
        type: String,
        required: false,
    },
    star: {
        type: Boolean
    },
    showMoreText: {
        type: Boolean
    }
})

const moreOptions = [
    {
        option: 'Import db'
    },
    {
        option: 'save db'
    },
]
const editable = ref(false)
let showMore = ref(true)
let showLess = ref(true)
const highlightStar = ref(false)

function makeEditable() {
    editable.value = true
}

function notEditable() {
    editable.value = false
}

function show() {
    if (showLess.value === true) {
        document.getElementById('expand').classList.replace('max-h-32', 'h-auto')
        showMore.value = false
        showLess.value = false
    }
}

function noShow() {
    if (showMore.value === false) {
        document.getElementById('expand').classList.replace('h-auto', 'max-h-32')
        showMore.value = true
        showLess.value = true
    }
}

function moreChoices() {
    document.getElementById('expandButton').classList.toggle('hidden')
}

function chooseOption() {
    document.getElementById('expandButton').classList.toggle('hidden')
    notEditable()
}

function highlightStars() {
    if (highlightStar.value === false) {
        highlightStar.value = true
    } else {
        highlightStar.value = false
    }

}

</script>
